import axiosInstance from '@/core/api'
import { components } from '@/schema'

export type GetShopItemImageUploadUrlResponse =
	components['schemas']['GetPresignedUrlResponse']

export type GetProfilePageBannerUploadUrlResponse =
	components['schemas']['GetPresignedUrlResponse']

export type GetBrokeNotificationUploadUrlResponse =
	components['schemas']['GetPresignedUrlResponse']

export type GetWithdrawSoundUploadUrlResponse =
	components['schemas']['GetPresignedUrlResponse']

export type UploadFileResponse = components['schemas']['UploadFileResponse']

export type GenerateFaviconsResponse =
	components['schemas']['GenerateFaviconsResponse']

export type UploadCustomCssDto = components['schemas']['UploadCustomCssDto']

export class FileService {
	static async getShopItemImageUploadUrl(
		fileExtension: string = 'jpg',
	): Promise<GetShopItemImageUploadUrlResponse> {
		const { data } =
			await axiosInstance.post<GetShopItemImageUploadUrlResponse>(
				'/admin/file/get-shop-item-image-upload-file-url',
				{ fileExtension },
			)
		return data
	}

	static async getProfilePageBannerUploadUrl(
		fileExtension: string = 'jpg',
	): Promise<GetProfilePageBannerUploadUrlResponse> {
		const { data } =
			await axiosInstance.post<GetProfilePageBannerUploadUrlResponse>(
				'/admin/file/get-profile-page-banner-upload-file-url',
				{ fileExtension },
			)
		return data
	}

	static async getBrokeNotificationUploadUrl(
		fileExtension: string = 'jpg',
	): Promise<GetBrokeNotificationUploadUrlResponse> {
		const { data } =
			await axiosInstance.post<GetBrokeNotificationUploadUrlResponse>(
				'/admin/file/get-broke-notification-upload-file-url',
				{ fileExtension },
			)
		return data
	}

	static async getWithdrawSoundUploadUrl(): Promise<GetWithdrawSoundUploadUrlResponse> {
		const { data } =
			await axiosInstance.post<GetWithdrawSoundUploadUrlResponse>(
				'/admin/file/get-withdraw-sound-upload-url',
				{ fileExtension: 'mp3' },
			)
		return data
	}

	static async uploadLogo(file: File): Promise<UploadFileResponse> {
		const formData = new FormData()
		formData.append('file', file)

		const { data } = await axiosInstance.post<UploadFileResponse>(
			'/admin/file/upload-logo',
			formData,
			{
				headers: {
					'Content-Type': 'multipart/form-data',
				},
			},
		)
		return data
	}

	static async uploadFavicon(file: File): Promise<GenerateFaviconsResponse> {
		const formData = new FormData()
		formData.append('file', file)

		const { data } = await axiosInstance.post<GenerateFaviconsResponse>(
			'/admin/file/upload-favicon',
			formData,
			{
				headers: {
					'Content-Type': 'multipart/form-data',
				},
			},
		)
		return data
	}

	static async uploadCustomCss(
		cssContent: string,
	): Promise<UploadFileResponse> {
		const { data } = await axiosInstance.post<UploadFileResponse>(
			'/admin/file/upload-custom-css',
			{ cssContent },
		)
		return data
	}

	static async uploadFileToPresignedUrl(
		url: string,
		file: File,
	): Promise<void> {
		await fetch(url, {
			method: 'PUT',
			body: file,
			headers: {
				'Content-Type': file.type,
			},
		})
	}
}
